jQuery( document ).ready(function($) {
    const appointmentsWrapper = $('.appointments-wrapper');
    const appointmentPrototype = appointmentsWrapper.find('.prototype');
    const appointmentsContainer = $('.appointments-container');
    const componentsContainer = $('.components-container');
    const contractsTable = $('.contracts-table');
    const form = $('.unauthenticated-enroll-form');
    const page = $('.reveal');

    if (form.length === 0) {
        return;
    }

    let selectedContracts = 0;
    let appointmentsAjax = false;

    if (contractsTable.length > 0) {
        contractsTable.reloadThisElement(function() {
            contractsTable.find('input[type=checkbox]').change(checker);
        });
        checker();
    } else {
        getAppointments();
    }


    if ($('input[name="course"]').length > 0) {
        const defaultCourse = $('input[name="course"]:checked').val();

        $('input[name="course"]').change(() => {
            const isDefault = $('input[name="course"]:checked').val() === defaultCourse;
            componentsContainer.find('input').prop('disabled', () => !isDefault);
            componentsContainer.find('.alternatives-warning').toggle(!isDefault);

            getAppointments();
        });
    }
    componentsContainer.find('input').change(getAppointments);

    form.ajaxFormSubmit(function(data){
        page.doneLoading();

        if (data.done === true) {
            foundationPopup('<h1>Inplannen geslaagd</h1>' +
                '<p>U heeft met succes alle inschrijvingen gedaan. Deze link zal worden gedeactiveerd.</p>' +
                '<div class="text-center"><a href="#" class="button primary close-this-tab">Sluiten</a></div>', function() {
                $('.close, .close-this-tab').unbind('click').click(function() {
                    window.close();
                });
            });
        } else {
            squde_flash('Inplannen geslaagd', 'success');
            if (contractsTable.length > 0) {
                contractsTable.reloadThisElement(function() {
                    contractsTable.find('input[type=checkbox]').unbind('change').change(checker);
                });
                checker();
            } else {
                getAppointments();
            }
        }
    }.bind([page]), function(xhr, status, error) {
        page.doneLoading();
        console.log([status,error]);
    }.bind([page]), function() {
        page.isLoading();
    });

    contractsTable.unbind('onReload').bind('onReload', () => {
        contractsTable.find('[data-hidden-checked]').remove();
    });


    function checker() {
        selectedContracts = contractsTable.find('tbody').find('input:checked').length;

        $('.number-of-contracts').html(selectedContracts);
        $('.show-if-number-of-contracts-not-1').toggle(selectedContracts !== 1);
        $('.show-if-number-of-contracts-1').toggle(selectedContracts === 1);
        form.find('[type="submit"]').attr('disabled', function(index, attr){
            return selectedContracts > 0 ? null : 'disabled';
        });

        getAppointments(selectedContracts);
    }

    function getAppointments(freeSpace = 1) {
        if (appointmentsAjax !== false) {
            appointmentsAjax.abort();
        }
        freeSpace = selectedContracts < 1  ? freeSpace : selectedContracts;

        appointmentPrototype.nextAll().not('.show-if-result-0').remove();
        appointmentsContainer.isLoading();

        const data = form.serializeJSON();
        data['freeSpace'] = freeSpace;

        appointmentsAjax = jQuery.ajax({
            url: appointmentsWrapper.attr('data-url'),
            data: data,
            success: function(data) {
                appointmentsWrapper.toggleClass('empty', data.length === 0);
                appointmentsWrapper.find('.show-if-result-0').toggle(data.length === 0);

                if (data.length === 0 && $('input[name="course"]').length > 1) {
                    const defaultInput = $('input[name="course"]:first');
                    const isDefault = $('input[name="course"]:checked').val() === defaultInput.val();
                    if (isDefault) {
                        const firstAlt = $('input[name="course"]:not(:first)');
                        defaultInput.attr('disabled', 'disabled');
                        firstAlt[0].checked = true;
                        firstAlt.trigger('change');
                    }
                }

                data.forEach(function(row) {
                    const clone = appointmentPrototype.clone();
                    const inputClone = appointmentPrototype.prev().clone();

                    const descriptionWrapper = clone.find('.description-wrapper');
                    descriptionWrapper.empty();
                    const spaceWrapper = clone.find('.space-wrapper');
                    spaceWrapper.empty();
                    const dateTimeWrapper = clone.find('.date-time-wrapper');
                    dateTimeWrapper.empty();
                    const locationWrapper = clone.find('.location-wrapper');
                    locationWrapper.empty();

                    row.siblings.forEach(function(appointment) {
                        descriptionWrapper.append('<span>' + appointment.description + '</span>');
                        spaceWrapper.append('<span>' + (appointment.max_count - appointment.student_count) + '</span>');

                        // get a day name for this date, like tuesday, but localized into Dutch
                        // set locale to nl for moment
                        moment.locale('nl');
                        const date = moment(appointment.start_date, 'DD-MM-YYYY');
                        const dayName = date.format('dddd DD-MM-YYYY');

                        dateTimeWrapper.append(`<span>${dayName} <small>${appointment.start_time} - ${appointment.end_time}</small></span>`);
                        const citySpan = makeAppointmentLocationLink(appointment);
                        locationWrapper.append(citySpan);
                    });

                    inputClone.attr('value', row.appointment_group_id);
                    inputClone.attr('id', 'appointment_group_' + row.appointment_group_id);

                    if (data.length === 1) {
                        inputClone.prop('checked', true);
                    }

                    clone.attr('for', 'appointment_group_' + row.appointment_group_id);


                    appointmentsWrapper.append(inputClone).append(clone);
                    clone.show();
                });
            },
            complete: function() {
                appointmentsContainer.doneLoading();
            }
        });
    }
});
